<template>
  <div class="default-bg result" :style="{ backgroundImage: 'url(/imgs/background_result' + (resultID + 1) + '.jpg)' }">
    <Header :bg_image="`topbanner_${resultID + 1}.png`" :color_idx="'white'"></Header>


    <div class="content">
      <span class="type">{{types[resultID]}}</span>

      <h1 :class="`color${resultID + 1}`">{{titles[resultID]}}</h1>
      <hr>
      <p>立即前往七色牆領取專屬小卡</p>
      <p>分享你的自信色彩</p>
      <button :class="`bg-color${resultID + 1}`" @click="restartQuiz">重新測驗</button>
    </div>

    <Footer :bg_image="`botbanner_${resultID + 1}.png`"></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: "result",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      results: {
        '11': 0,
        '12': 5,
        '13': 0,
        '14': 2,
        '21': 2,
        '22': 5,
        '23': 4,
        '24': 4,
        '31': 1,
        '32': 4,
        '33': 1,
        '34': 3,
        '41': 6,
        '42': 3,
        '43': 6,
        '44': 3
      },
      types: [
        '大膽吸睛型',
        '甜美浪漫型',
        '耀眼時尚型',
        '明亮迷人型',
        '優雅自信型',
        '不羈優雅型',
        '熱情創新型'
      ],
      titles: [
        '時尚是\n寧願忠於自己\n也不要美的雷同',
        '甜美與單純\n源自於你\n心靈深處的浪漫',
        '對我來說\n一個人的迷人光采\n來自於對細節的專注',
        '經歷與想像力\n才是展現\n燦爛魅力的關鍵',
        '真正的風格自信\n透過一個眼神已經\n說明了我是誰',
        '美的極致\n且從容的樣貌\n就是優雅',
        '我就是那抹\n無人能比擬的\n耀眼色彩'
      ]
    }
  },
  computed: {
    resultID() {
      return this.results[this.$store.getters.getAnswers]
    }
  },
  methods: {
    restartQuiz() {
      this.$store.commit('resetAnswer')
      this.$router.push(`/`)
    }
  }
}
</script>

<style lang="scss">
  .result {
    animation: fadeInContent 1.5s ease-in-out;
    .header, .footer {
      img {
        opacity: 1;
      }
    }
    .content {
      span.type {
        position: absolute;
        top: 85px;
        left: calc( 50% + 40px );
        z-index: 1000;
        color: #fff;
        font-size: 1.5rem;
        text-shadow: 1px 1px 6px #ababab;
      }
      h1 {
        margin: 0 auto;
        padding-top: 40px;
        white-space: pre-wrap; 
        word-wrap: break-word;
        font-size: 2.3rem;
        line-height: 3rem;
        text-align: left;
      }
      hr {
        width: 15px;
        margin: 20px auto;
        border-color: #979797;
        border-width: 0.5px;
      }
      p {
        margin-bottom: 5px;
      }
      button {
        margin: 0 auto;
        padding: 5px 0;
        margin-top: 30px;
        width: 150px;
        font-size: 1.1rem;
        margin-top: 45px;
        color: #fff;
        background-color: #666666;
        border-color: transparent; 
      }
    }
  }
  @media screen and (max-width: 768px) {
    .result {
      .content {
        h1 { 
          font-size: 2.1rem;
          padding-top: 80px;
        }
      }
    }
  }
  @media screen and (max-width: 330px) {
    .result {
      .content {
        span.type {
          font-size: 1.3rem;
        }
        h1 { 
          padding-top: 85px;
        }
      }
    }
  }
</style>